import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MemberViewModel } from "src/app/common/models/MemberViewModel";
import { MultiMediaBasicInfo } from "src/app/common/models/MultiMediaBasicInfo";
import { MembereditorService } from "../../membereditor/services/membereditor.service";
import { ResponseModel } from "src/app/common/models/ResponseModel";
import { IndividualMultiMediaViewModel } from "src/app/common/models/IndividualMultiMediaViewModel";
import { first } from "rxjs/operators";
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { ParentMessageType } from 'src/app/common/models/ParentMessage';
import { ImageCarouselActions } from 'src/app/common/models/ImageCarouselActions';
import { ImageCarouselActionsTypes } from 'src/app/common/enums/enums';
import { Subscription } from 'rxjs';



@Component({
    selector: "app-image-carousel",
    templateUrl: "./image-carousel.component.html",
    styleUrls: ["./image-carousel.component.scss"],
    standalone: false
})
export class ImageCarouselComponent implements OnInit {
  // Variable declaration
  isMenuOpened: boolean = false;
  currentMediaIndex: number = 0;
  isDisabled: boolean = true;
  errorImg: string = "assets/images/no-image.jpg";
  isEnableSetPrimary: boolean = false;
  isEnableForUnlnik: boolean = false;
  timeStamp: any;
  rootMemberChangedServiceSubscription: Subscription;

  // Object declaration
  memberMediaViewData: IndividualMultiMediaViewModel;
  selectedImage: MultiMediaBasicInfo;
  carouselImages: MultiMediaBasicInfo[] = [];

  // Decorator  declaration
  @Input() defaultImage: any;
  @Input() isMediaChanged: boolean;
  @Output() profileImageFunction = new EventEmitter<any>();

  constructor(private membereditorService: MembereditorService, private parentCommunicatorService: ParentCommunicatorService) { }

  ngOnInit(): void {
    this.rootMemberChangedServiceSubscription = this.membereditorService.onRootMemberChanged().subscribe(() =>
      this.selectedMemberMediaDetails()
    );
    this.selectedMemberMediaDetails();
    this.currentMediaIndex = 0;
  }

  ngOnDestroy(): void {
    if (this.rootMemberChangedServiceSubscription) {
      this.rootMemberChangedServiceSubscription.unsubscribe();
    }
  }

  ngOnChanges() {
    if (this.isMediaChanged) {
      this.selectedMemberMediaDetails();
      this.currentMediaIndex = 0;
      this.isMediaChanged = !this.isMediaChanged;
    }
  }

  selectedMemberMediaDetails() {
    this.timeStamp = performance.now();
    this.selectedImage = new MultiMediaBasicInfo();
    this.memberMediaViewData = new IndividualMultiMediaViewModel();
    this.membereditorService.getReferencedMultimedias().pipe(first())
      .subscribe((response: ResponseModel<IndividualMultiMediaViewModel>) => {
        console.log("Member data received");
        this.memberMediaViewData = null;
        this.memberMediaViewData = response.data;
        this.setImagesForCarousel(this.memberMediaViewData);
        this.isMenuOpened = false;
      })
      .add(() => {
        // this.loadingService.Hide(processId);
      });
  }

  setImagesForCarousel(memberMediaViewData: IndividualMultiMediaViewModel) {
    this.currentMediaIndex = 0;
    this.carouselImages = [];
    this.selectedImage = memberMediaViewData.media.find((x) => x.id == memberMediaViewData.selectedMultimediaId);
    if (this.selectedImage == null) {
      let defaultImage = new MultiMediaBasicInfo();
      defaultImage.mediaUrl = this.defaultImage;
      this.carouselImages.push(defaultImage);
      this.carouselImages = this.carouselImages.concat(memberMediaViewData.media);
    }
    else {
      this.carouselImages = memberMediaViewData.media;
    }
  }

  showDropDown() {
    this.isMenuOpened = !this.isMenuOpened;
    this.enableImageAction();
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(ParentMessageType.ShowInformation, "not_implemented");
  }

  getCarouselImageUrl(image: MultiMediaBasicInfo) {
    return (image.mediaUrl != null && image.fileName != null) ? image.mediaUrl + '&v=' + this.timeStamp : image.mediaUrl;
  }

  getNextItem() {
    this.currentMediaIndex = this.currentMediaIndex + 1;
    this.isMenuOpened = false;
  }

  getPreviousItem() {
    this.currentMediaIndex = this.currentMediaIndex - 1;
    this.isMenuOpened = false;
  }

  uploadImage() {
    let profImageFunctions = new ImageCarouselActions;
    profImageFunctions.type = ImageCarouselActionsTypes.Upload;
    profImageFunctions.selectedMediaInfo = this.carouselImages[this.currentMediaIndex];
    this.profileImageFunction.emit(profImageFunctions);
    this.isMenuOpened = !this.isMenuOpened;
  }

  //set selected media as primary
  setImageAsPrimary() {
    if (this.isEnableSetPrimary) {
      let profImageFunctions = new ImageCarouselActions;
      profImageFunctions.type = ImageCarouselActionsTypes.SetAsPrimary;
      profImageFunctions.selectedMediaInfo = this.carouselImages[this.currentMediaIndex];
      this.profileImageFunction.emit(profImageFunctions);
      this.isMenuOpened = !this.isMenuOpened;
    }
  }

  editImage() {
    let profImageFunctions = new ImageCarouselActions;
    profImageFunctions.type = ImageCarouselActionsTypes.Edit;
    profImageFunctions.selectedMediaInfo = this.carouselImages[this.currentMediaIndex];
    this.profileImageFunction.emit(profImageFunctions);
    this.isMenuOpened = !this.isMenuOpened;
  }

  //unlink selected image from individual
  unlinkImage() {
    if (this.isEnableForUnlnik) {
      let profImageFunctions = new ImageCarouselActions;
      profImageFunctions.type = ImageCarouselActionsTypes.Unlink;
      profImageFunctions.selectedMediaInfo = this.carouselImages[this.currentMediaIndex];
      this.profileImageFunction.emit(profImageFunctions);
      this.isMenuOpened = !this.isMenuOpened;
    }
  }

  //enable disable set primary image option
  enableImageAction() {
    if (this.carouselImages.length > 1) {
      if (this.memberMediaViewData.selectedMultimediaId > 0) {
        this.isEnableSetPrimary = (this.carouselImages[this.currentMediaIndex].id == this.memberMediaViewData.selectedMultimediaId) ? false : true;
        this.isEnableForUnlnik = true;
      }
      else {
        this.isEnableSetPrimary = this.currentMediaIndex == 0 ? false : true;
        this.isEnableForUnlnik = this.currentMediaIndex == 0 ? false : true;
      }
    }
    else {
      this.isEnableSetPrimary = false;
      this.isEnableForUnlnik = (this.carouselImages.length == 1 && this.memberMediaViewData.selectedMultimediaId > 0) ? true : false;
    }
  }
}
